module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-02-m.903504ce3ee70860c90ae3f2f0997000.png";